module.exports = __webpack_public_path__ + "static/media/account_linked.ce534205.svg";